import React from 'react'
import styled from 'styled-components'
import { Tooltip } from "antd";
import { getParameterByName } from "@/utils/utils";

const LabelWrapper = styled.div`
  max-width: 90%;
  overflow: hidden;
`

const Labels = styled.span`
  display: inline-block;
  padding: 0 4px;
  margin-right: 4px;
  height: 20px;
  background: #E9E9E9;
  border-radius: 2px;
  text-align: center;
  color: #595959; 
  line-height: 20px;
`
const UserLabels = (props) => {
  const { labels } = props
  if (labels && labels.length) {
    return (
      <>
        {
          getParameterByName("deviceType") === "iframe" ?
            <Tooltip
              placement="left"
              title={labels.map(item => {
                return <Labels key={item}>{item}</Labels>
              })}
              color="#fff"
              overlayClassName="white-background"
            >
              <LabelWrapper style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", width: "272px" }}>
                {
                  labels.map(item => {
                    return <Labels key={item}>{item}</Labels>
                  })
                }
              </LabelWrapper>
            </Tooltip> :
            <LabelWrapper>
              {
                labels.map(item => {
                  return <Labels key={item}>{item}</Labels>
                })
              }
            </LabelWrapper>
        }
      </>


    )
  } else {
    return null
  }
}

export default UserLabels